import * as React from 'react';
import { ErrorOutline, Refresh } from '@mui/icons-material';
import { Button } from 'components';
import { TErrorDisplay } from './ErrorDisplay.types';
import './ErrorDisplay.styled.scss';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

export const ErrorDisplay: TErrorDisplay = ({ title, text, onReload }) => {
  const localize = useLocalize();
  const displayTitle = title ?? localize('products.error.title');
  const displayText = text ?? localize('products.error.description');

  return (
    <div className="error-display">
      <ErrorOutline className="error-display__icon" />
      <h3 className="error-display__title">{displayTitle}</h3>
      <p className="error-display__text">{displayText}</p>
      {onReload && (
        <Button
          variant="contained"
          startIcon={<Refresh />}
          onClick={onReload}
          className="error-display__retry-button"
        >
          {localize('products.error.retry')}
        </Button>
      )}
    </div>
  );
};
